export default "__VITE_ASSET__16c9aff6__"